import { useEffect, useState } from 'react';
import './profile.scss';
import { Form, Formik } from 'formik';
import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import { object, string } from 'yup';
import InputForm from '../../commun/input-form';
import { UserDto } from '../../../services/dtos/user.dto';
import { ContactDetailsDto } from '../../../services/dtos/contact-details.dto';
import { ERROR_MAIL } from '../../../utils/constants.utils';
import { Warning } from '@mui/icons-material';
import { getContract, getContracts } from '../../../services/contracts.service';

//Props d'entrée de la fonction ContactDetailsForm
type Props = {
    handlerSubmit: (e: ContactDetailsDto) => void;
    user?: UserDto;
    contactFormSend: boolean;
};

/**
 * Vue qui permet d'afficher et de moddifier les données de contact
 * @param handlerSubmit handler du sumbmit
 * @param user utilisateur courrant
 * @param contactFormSend permet de savoir si le formulaire à été envoyé
 * @constructor
 */
function ContactDetailsForm({ handlerSubmit, user, contactFormSend }: Props) {
    //useState
    const [initialValues, setInitialValues] = useState<ContactDetailsDto>({
        identifiant: user?.identifiant,
        telPort: '',
        telFixe: '',
        mailPerso: '',
        mailPro: '',
    });

    const [existContractTelereleve, setExistContractTelereleve] = useState(false);

    useEffect(() => {
        //MAJ initiales
        if (user !== undefined) {
            //On initialise les valeurs quand l'utilisateur est chargé
            setInitialValues({
                ...initialValues,
                telPort: user.telPort ? user.telPort : '',
                telFixe: user.telFixe ? user.telFixe : '',
                mailPerso: user.mailPerso ? user.mailPerso : '',
                mailPro: user.mailPro ? user.mailPro : '',
            });

            getContracts().then(result => {
                if (Array.isArray(result)) {
                    result.forEach(contract => {
                        if (contract['@id'] && typeof contract['@id'] === 'string') {
                            // Supprime "/rattachement_contrats/"
                            contract['@id'] = contract['@id'].replace('/rattachement_contrats/', '');
                        }
                        getContract(contract['@id']).then(res => {
                            if (res && res?.telereleve) {
                                setExistContractTelereleve(true);
                            }
                        });
                    });
                }
            });
        }

        //https://stackoverflow.com/questions/55840294/how-to-fix-missing-dependency-warning-when-using-useeffect-react-hook
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    //Permet gérer la validation du formulaire
    const nbCaracteresTel = 10;
    const validationSchema = object({
        //Controle du champ tel
        //Controle : obligatoire / taille / format
        telPort: string()
            .matches(/^\d+$/, {
                message: 'Caractère non valide inséré.',
            })
            .length(nbCaracteresTel, "Merci d'entrer 10 caractères."),
        //Controle du champ tel
        //Controle : obligatoire / taille / format
        telFixe: string()
            .matches(/^\d+$/, {
                message: 'Caractère non valide inséré.',
            })
            .length(nbCaracteresTel, "Merci d'entrer 10 caractères."),
        //Controle du champ mail
        //Controle : obligatoire / taille / format
        mailPerso: string()
            .email(ERROR_MAIL)
            .required("L'email personnel est obligatoire")
            .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, ERROR_MAIL),
        //Controle du champ mail
        //Controle : obligatoire / taille / format
        mailPro: string()
            .email(ERROR_MAIL)
            .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, ERROR_MAIL),
    });

    return (
        //Formulaire de informations de contacts
        <Box className="contact-details">
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Typography variant={'h5'}>Modifier mes adresses de contact</Typography>
                </Grid>
                <Grid item xs={12} md={6} sx={{ textAlign: 'right' }}>
                    <Typography variant={'subtitle2'}>* : champs obligatoires</Typography>
                </Grid>
            </Grid>
            <Paper>
                <Formik
                    enableReinitialize
                    initialValues={initialValues}
                    onSubmit={handlerSubmit}
                    validationSchema={validationSchema}
                >
                    <Form>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={4}>
                                <InputForm
                                    required
                                    id="mailPerso"
                                    name="mailPerso"
                                    label="Email personnel"
                                    type="email"
                                />
                            </Grid>
                            <Grid item xs={12} sx={{ display: 'none' }}>
                                <InputForm id="mailPro" name="mailPro" label="Email professionnel" type="email" />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <InputForm id="telPort" name="telPort" label="Téléphone portable" type="tel" />
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <InputForm id="telFixe" name="telFixe" label="Téléphone fixe" type="tel" />
                            </Grid>
                            {existContractTelereleve && (
                                <Grid item xs={12}>
                                    <Typography variant={'subtitle2'}>
                                        <Warning /> La suppression de votre/vos numéro(s) de téléphone pour les alertes
                                        fuite d'eau entraînera une alerte par email au lieu du SMS.
                                    </Typography>
                                </Grid>
                            )}
                            <Grid item xs={12} className={'buttons-form'}>
                                <Typography variant={'button'}>
                                    <Button type="submit" variant="contained" disabled={contactFormSend}>
                                        Valider
                                    </Button>
                                </Typography>
                            </Grid>
                        </Grid>
                    </Form>
                </Formik>
            </Paper>
        </Box>
    );
}

export default ContactDetailsForm;
